import type { StudioModule } from "../modules";

export function ComingSoonPage({ module }: { module: StudioModule }) {
  return (
    <div className="list-page">
      <div className="coming-soon">
        <div className="coming-soon-icon"><module.icon size={44} stroke={1.5} /></div>
        <h1>{module.label}</h1>
        <span className="badge badge-draft">coming soon</span>
        {module.description && <p className="muted">{module.description}</p>}
      </div>
    </div>
  );
}
